import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import RouteCollection from '@bd/bdcore-named-routes';
import { get } from 'lodash';
import { Link as RRLink } from 'react-router-dom';

class SearchBarBtns extends React.Component {

  getUrl = routeName => {
    const { filters } = this.props;
    let query = '';

    const filterQuery = {
      AreaMetro: get(filters, 'AreaMetro', []).map(value => value.label),
      AreaSubMetro: get(filters, 'AreaSubMetro', []).map(value => value.label),
    };

    const pathParams = {
      communityMarketAreaMetro: filterQuery.AreaMetro.length === 1
      ? filterQuery.AreaMetro[0]
      : undefined,
      communityMarketAreaSubMetro: (
        filterQuery.AreaMetro.length === 1
        && filterQuery.AreaSubMetro.length === 1
      )
      ? filterQuery.AreaSubMetro[0]
      : undefined,
    };

    const urlFilters = {};

    if (filterQuery.AreaMetro.length > 1) {
      urlFilters.AreaMetro = filterQuery.AreaMetro;
    }

    if (
      filterQuery.AreaSubMetro.length > 1
      || (filterQuery.AreaMetro.length === 0 && filterQuery.AreaSubMetro.length)
    ) {
      urlFilters.AreaSubMetro = filterQuery.AreaSubMetro;
    }

    if (Object.keys(urlFilters).length > 0) {
      const urlParams = new URLSearchParams('');
      urlParams.set('filters', JSON.stringify(urlFilters));
      query = `?${urlParams.toString()}`;
    }

    return `${RouteCollection.getPath(routeName, pathParams)}${query}`;
  }

  render() {
    const { homes, communities, plans, tab } = this.props;
    const parentCommunity = communities.filter(item => !get(item, 'exclusive_lot_size'));
    return (
      <div>
        {
          tab === 'homes' &&
          <RRLink to={this.getUrl('homes')} className="btn btn-brand3 btn-block">Search <span>{`${homes.length} Results`}</span></RRLink>
        }
        {
          tab === 'communities' &&
          <RRLink to={this.getUrl('communities')} className="btn btn-brand3 btn-block">Search <span>{`${parentCommunity.length} Results`}</span></RRLink>
        }
        {
          tab === 'plans' &&
          <RRLink to={this.getUrl('plans')} className="btn btn-brand3 btn-block">Search <span>{`${plans.length} Results`}</span></RRLink>
        }
      </div>
    );
  }
}

SearchBarBtns.propTypes = {
  communities: PropTypes.arrayOf(PropTypes.object).isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  filters: PropTypes.object.isRequired,
  tab: PropTypes.string.isRequired,
};

SearchBarBtns.defaultProps = {
};

export default withData({
  communities: true,
  homes: true,
  plans: true,
  filters: true,
})(SearchBarBtns);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/QuickSearch/SearchBarBtns.js